import InputTitle from "components/Form/InputTitle";
import { Col } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { v4 } from "uuid";
import InputGroupFieldError from "./InputGroupFieldError";

const InputGroupField = ({
  parentName,
  index,
  input,
  locale,
  register,
  errors,
  rules = { required: <FormattedMessage id="requiredField" /> },
  ...reset
}) => {
  return (
    <Col lg={reset.lg} xs={12} key={v4()}>
      <div className={`form-group ${rules?.required ? "required" : ""}`}>
        {(!!input?.name || !!input?.langId) && (
          <InputTitle name={input?.langId ?? input?.name} locale={locale} />
        )}
        <input
          type="text"
          className="form-control form-outline"
          {...register(
            `${parentName}.${index}${input?.name ? `.${input?.name}` : ""}${
              locale ? `.${locale}` : ""
            }`,
            rules
          )}
          {...reset}
        />
        <InputGroupFieldError
          errors={errors}
          index={index}
          name={parentName}
          input={input}
          locale={locale}
        />
      </div>
    </Col>
  );
};

export default InputGroupField;
